import React from 'react';

export const toggleClassNameInTag = (tagName: string, className: string, condition: boolean, doc = document) => {
    const tag = doc.getElementsByTagName(tagName);
    if (!tag || tag.length === 0) {
        return;
    }
    if (condition) {
        tag[0].classList.add(className);
    } else {
        tag[0].classList.remove(className);
    }
};

export const setAttributeInTag = (tagName: string, attributeName: string, value: string, doc = document) => {
    const tag = doc.getElementsByTagName(tagName);
    if (!tag || tag.length === 0) {
        return;
    }
    tag[0].setAttribute(attributeName, value);
};

export const DefaultScrollIntoViewOptions = { behavior: 'auto', block: 'center' } as ScrollIntoViewOptions;
export const HorizontalScrollOnlyScrollIntoViewOptions = { block: 'nearest', inline: 'center', behavior: 'smooth' } as ScrollIntoViewOptions;

export const scrollIntoView = (tag: HTMLCollection, options = DefaultScrollIntoViewOptions) => {
    if (!tag || tag.length === 0) {
        return;
    }
    if (tag.length > 0) {
        tag[0].scrollIntoView(options);
    }
};

export const scrollIntoViewWithSelector = (querySelector: string, options = DefaultScrollIntoViewOptions, doc = document) => {
    const tag = doc.querySelector(querySelector);
    if (!tag) {
        return;
    }
    tag.scrollIntoView(options);
};

export const changeStyleInElement = (tag: Element, styles: Partial<CSSStyleDeclaration>, doc = document) => {
    if (tag && 'style' in tag) {
        const styleAttr = (tag as HTMLElement).style;
        Object.keys(styles).forEach((key) => {
            // @ts-ignore
            styleAttr[key] = styles[key] as string;
        });
    }
};

export const changeStyleInTag = (tagName: string, styles: Partial<CSSStyleDeclaration>, doc = document) => {
    const htmlTag = doc.getElementsByTagName(tagName);
    if (htmlTag && htmlTag.length > 0) {
        changeStyleInElement(htmlTag[0], styles, doc);
    }
};

export const findTagByQuery = (querySelector: string, doc = document) => {
    return doc.querySelector(querySelector);
};

export const findTagByQueryAll = (querySelector: string, doc = document) => {
    return doc.querySelectorAll(querySelector);
};

export const focusElementByDataElementNameSelector = (dataElementName: string, doc = document) => {
    const elements = doc.querySelectorAll<HTMLElement>(`[data-element-name=${dataElementName}]`);
    if (elements && elements.length > 0) {
        elements[0].focus();
        return true;
    }
    return false;
};

export const findElementHeight = (element: HTMLElement) => {
    return element.offsetHeight;
};

export const findTagByDataElementName = (dataElementName: string, doc = document): HTMLElement | null => {
    return doc.querySelector(`[data-element-name="${dataElementName}"]`);
};

export const tagOrBodyDefault = (element: Element | null | undefined, doc = document): Element => {
    return element || doc.body;
};

export interface CancellableEvent {
    stopPropagation: () => void;
    preventDefault: () => void;
}

export const killEvent = (e: Event | CancellableEvent | undefined) => {
    if (!e) return;
    if (e.stopPropagation) {
        e.stopPropagation();
    }
    if (e.preventDefault) {
        e.preventDefault();
    }
};

// Remove once integrate SearchBoxPopoverFeature
export const notEnterOrSpaceKeydown = (e: React.KeyboardEvent | React.MouseEvent) => {
    return e.type === 'keydown' && 'key' in e && e.key !== 'Enter' && e.key !== ' ';
};

export const addEventListenerToWindow = <K extends keyof WindowEventMap>(
    type: K,
    listener: (this: Window, ev: WindowEventMap[K]) => unknown,
    options?: boolean | AddEventListenerOptions,
) => {
    window.addEventListener(type, listener, options);
};

export const removeEventListenerFromWindow = <K extends keyof WindowEventMap>(
    type: K,
    listener: (this: Window, ev: WindowEventMap[K]) => unknown,
    options?: boolean | AddEventListenerOptions,
) => {
    window.removeEventListener(type, listener, options);
};

export const stripHtmlTags = (input?: string): string | undefined => {
    if (!input) return input;
    const textWithNewLineAndTags = input.replace(/<br\s*\/>/gi, '\n');
    return textWithNewLineAndTags
        .replace(/(<([^>]+)>)/gi, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
};
